export default __webpack_public_path__ + "static/media/default-image.2e01288c.jpeg";